import { render, staticRenderFns } from "./LogoutBtn.vue?vue&type=template&id=601cca80&scoped=true&"
import script from "./LogoutBtn.vue?vue&type=script&lang=js&"
export * from "./LogoutBtn.vue?vue&type=script&lang=js&"
import style0 from "./LogoutBtn.vue?vue&type=style&index=0&id=601cca80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601cca80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListItem,VListItemAction,VListItemContent,VListItemTitle})
